import NTopNBottom from '../../components/NTopNBottom'
import calcRemFn from '../calcRem'

import bannerImg from '../../assets/supersenseGarden/banner.jpg'
import navColor from '../../assets/supersenseGarden/nav/color.jpg'
import navBgFixed from '../../assets/supersenseGarden/nav/nav_bg_fix.png'

import p1_1 from '../../assets/supersenseGarden/ctn/1_1.jpg'
import p1_2 from '../../assets/supersenseGarden/ctn/1_2.jpg'
import p1_3 from '../../assets/supersenseGarden/ctn/1_3.jpg'
import p1_4 from '../../assets/supersenseGarden/ctn/1_4.jpg'
import p1_5 from '../../assets/supersenseGarden/ctn/1_5.jpg'
import p1_6 from '../../assets/supersenseGarden/ctn/1_6.jpg'
import p2_1 from '../../assets/supersenseGarden/ctn/2_1.jpg'
import p2_2 from '../../assets/supersenseGarden/ctn/2_2.jpg'
import p2_3 from '../../assets/supersenseGarden/ctn/2_3.jpg'
import p2_4 from '../../assets/supersenseGarden/ctn/2_4.jpg'
import p2_5 from '../../assets/supersenseGarden/ctn/2_5.jpg'
import p2_6 from '../../assets/supersenseGarden/ctn/2_6.jpg'
import p3_1 from '../../assets/supersenseGarden/ctn/3_1.jpg'
import p3_2 from '../../assets/supersenseGarden/ctn/3_2.jpg'
import p4_1 from '../../assets/supersenseGarden/ctn/4_1.jpg'
import p4_2 from '../../assets/supersenseGarden/ctn/4_2.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'


// 需要手动修改proId
const top1_id = IS_PROD ? '99423' : '99423'
const top2_id = IS_PROD ? '99422' : '99422'
const top3_id = IS_PROD ? '99426' : '99426'
const top4_id = IS_PROD ? '99424' : '99424'

const navCss = {
  navWrap: {
    minHeight: calcRemFn(139),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(139),
    transition: 'all 0.3s ease'
  },
  navCtnFixed: {
    height: calcRemFn(139),
    backgroundImage: `url(${navBgFixed})`,
    backgroundPosition: `0 0`,
  },
  topBtnLayout: {
    paddingTop: `${calcRemFn(26)}`,
    marginLeft: `${calcRemFn(271)}`,
    flexWrap: 'wrap',
  },
  topBtnBaseCss: {
    width: calcRemFn(86),
    height: calcRemFn(25),
    opacity: 0
  },
  bottomBtnLayout: {
    display: 'none'
  },
}

const navData = {
  component: NTopNBottom,
  css: ['a','b','c'],
  top: [
    {
      key: 'top1',
      show: true,
    },
    {
      key: 'top2',
      show: true,
    },
    {
      key: 'top3',
      show: true,
    },
    {
      key: 'top4',
      show: true,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: false,
        prodId: top1_id
      },
    ],
    top2: [
      {
        key: '_i2',
        show: false,
        prodId: top2_id
      },
    ],
    top3: [
      {
        key: '_i3',
        show: false,
        prodId: top3_id
      },
    ],
    top4: [
      {
        key: '_i4',
        show: false,
        prodId: top4_id
      },
    ],
  }
}

const pictures = [
  {
    id: top1_id,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1,
      p1_2,
      p1_3,
      p1_4,
      p1_5,
      p1_6,
    ],
    name: '丛林'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p2_1,
      p2_2,
      p2_3,
      p2_4,
      p2_5,
      p2_6,
    ],
    name: '花语'
  },
  {
    id: top3_id,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p3_1,
      p3_2
    ],
    name: '亮相'
  },
  {
    id: top4_id,
    type: 'blue',
    ref: 'top4_i1',
    farName: 'top4',
    sonName: '_i1',
    son: [
      p4_1,
      p4_2,
    ],
    name: '幻境',
  }
]

const topDiff = {
  firstSon: '_i1',
  top1_i1: 0,
  top2_i1: 0,
  top3_i1: 0,
}

export default {
  title: '超感花园',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
